import { render, staticRenderFns } from "./BrokerDashboard.vue?vue&type=template&id=2715b44f&scoped=true&lang=pug"
import script from "./BrokerDashboard.vue?vue&type=script&lang=js"
export * from "./BrokerDashboard.vue?vue&type=script&lang=js"
import style0 from "./BrokerDashboard.vue?vue&type=style&index=0&id=2715b44f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2715b44f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IchraBadge: require('/home/docker/code/frontend/components/IchraBadge.vue').default,Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
